// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"QZ-z","colorTextValue":"RZ-z","swatches":"SZ-z","collapseLink":"TZ-z","isCollapsed":"UZ-z","dropdown":"VZ-z","disabled":"WZ-z"};